function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMembershipcardThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 19"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24.68.33a1.1 1.1 0 0 0-.77-.33H1.09a1.1 1.1 0 0 0-.77.33 1.1 1.1 0 0 0-.32.79v16.76a1.1 1.1 0 0 0 .32.79 1.1 1.1 0 0 0 .77.33h22.82a1.1 1.1 0 0 0 .77-.33 1.1 1.1 0 0 0 .32-.79V1.12a1.1 1.1 0 0 0-.32-.79M24 17.88a.13.13 0 0 1 0 .1.06.06 0 0 1-.05 0H1.09A.06.06 0 0 1 1 18a.13.13 0 0 1 0-.1V1.12A.13.13 0 0 1 1 1a.06.06 0 0 1 .05 0h22.86A.06.06 0 0 1 24 1a.13.13 0 0 1 0 .1Z",
  style: {
    fill: "#010101",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 7.8v1.6a.45.45 0 0 0 .45.44h.12L7 9.32l1.45.51h.14A.45.45 0 0 0 9 9.4V7.8l.92-1.28a.5.5 0 0 0 .08-.13.47.47 0 0 0-.28-.57l-1.49-.47-.88-1.3a.27.27 0 0 0-.1-.11.41.41 0 0 0-.6.11l-.88 1.3-1.47.47-.13.07a.46.46 0 0 0-.08.63Zm1.16-1.63A.44.44 0 0 0 6.39 6L7 5.09l.62.9a.4.4 0 0 0 .22.18l1 .33-.64.88a.47.47 0 0 0-.09.28v1.11l-1-.36a.45.45 0 0 0-.28 0l-1 .36V7.66a.47.47 0 0 0-.09-.28l-.6-.88Z",
  style: {
    fill: "#010101",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 10.86h8v1h-8zM4 13.86h17v1H4z",
  style: {
    fill: "#010101"
  }
}));
export default SvgMembershipcardThin;